// extracted by mini-css-extract-plugin
export default {"container":"smsCodeInput-module__container__uq7dc","input":"smsCodeInput-module__input__Oj7km","errorMessage":"smsCodeInput-module__errorMessage__tmSXX"};